import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import { JWT } from "../../constants/local-storage";

export default function AdministrationHoMeConfiguration() {

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const [config, setConfig] = useState({
    // Links
    isLiveLinkScans: false,
    isLiveLinkSpace: false,
    isLiveLinkUtilisation: false,
    isLiveLinkLeases: false,
    isLiveLinkTickets: false,
    isLiveLinkProjects: false,

    // KPIs
    areaScanned: "",
    kpiSqft: "",
    kpiHhc: "",
    kpiSqfthhc: "",

    // Leasing
    leasedProperties: "",
    leasedPercentage: "",
    leasedSqft: "",
    leasedRent: "",
    leasedQ1: "",
    leasedQ2: "",
    leasedQ3: "",
    leasedQ4: "",

    // PPM
    ppmTotal: "",
    ppmRed: "",
    ppmAmber: "",
    ppmGreen: "",

    // Projects
    projectsTotal: "",
    projectsRed: "",
    projectsAmber: "",
    projectsGreen: ""
  });

  const thisContainer = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    paddingTop:'40px',
    height: "150vh",
    backgroundColor:'white'
  };

  const contentStyle = {
    marginLeft: "220px",
    padding: "40px",
  };

  const buttonStyle = {
    padding: "12px 20px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
  };

  const spinnerStyle = {
    width: "40px",
    height: "40px",
    border: "4px solid #eee",
    borderTop: "4px solid #007bff",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    marginTop: "20px"
  };

  // 🔥 LOAD EXISTING CONFIG
  useEffect(() => {
    loadConfig();
  }, []);

  async function loadConfig() {
    try {
      const response = await fetch("/resolutionsoftwareplatform/home-setup", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem(JWT)
        }
      });

      const data = await response.json();
      if (data) {
        setConfig(prev => ({ ...prev, ...data }));
      }

    } catch (e) {
      console.error(e);
    }
  }

  function handleChange(e) {
    const { name, value, type, checked } = e.target;

    setConfig(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  }

  // 🔥 SAVE
  async function handleSave() {
    setLoading(true);
    setMessage(null);

    try {
      const response = await fetch("/resolutionsoftwareplatform/home-setup/save", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem(JWT)
        },
        body: JSON.stringify(config)
      });

      const text = await response.text();
      setMessage(text);

    } catch (e) {
      console.error(e);
      setMessage("Save failed 😬");
    }

    setLoading(false);
  }

  // 🎨 STYLES
  const cardStyle = {
    background: "#ffffff",
    borderRadius: "10px",
    padding: "20px",
    marginBottom: "20px",
    border: "1px solid #e5e5e5"
  };

  const sectionTitle = {
    fontSize: "16px",
    fontWeight: "600",
    marginBottom: "15px"
  };

  const gridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
    gap: "12px"
  };

  const inputStyle = {
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "13px"
  };

  const checkboxRow = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "8px"
  };

  const fieldWrapper = {
    display: "flex",
    flexDirection: "column",
    fontSize: "12px"
  };

  const labelStyle = {
    marginBottom: "4px",
    color: "#666",
    textTransform: "capitalize"
  };

  return (
    <div style={thisContainer}>
      <Header />
      <LeftMenu />

      <div style={contentStyle}>

        <h2 style={{ marginBottom: "25px" }}>Home Dashboard Configuration</h2>

        {/* 🔗 LINKS */}
        <div style={cardStyle}>
          <div style={sectionTitle}>🔗 Links Enabled</div>

          {Object.keys(config)
            .filter(k => k.startsWith("isLive"))
            .map(key => (
              <div key={key} style={checkboxRow}>
                <input
                  type="checkbox"
                  name={key}
                  checked={config[key] || false}
                  onChange={handleChange}
                />
                <span>
                  {key.replace("isLiveLink", "")
                      .replace(/([A-Z])/g, " $1")
                      .toLowerCase()}
                </span>
              </div>
            ))}
        </div>

        {/* 📊 KPIs */}
        <div style={cardStyle}>
          <div style={sectionTitle}>📊 KPIs</div>

          <div style={gridStyle}>
            {["areaScanned","kpiSqft","kpiHhc","kpiSqfthhc"].map(field => (
              <div key={field} style={fieldWrapper}>
                <label style={labelStyle}>{field.replace(/([A-Z])/g, " $1").toLowerCase()}</label>
                <input
                  name={field}
                  value={config[field] || ""}
                  onChange={handleChange}
                  style={inputStyle}
                />
              </div>
            ))}
          </div>
        </div>

        {/* 🏢 Leasing */}
        <div style={cardStyle}>
          <div style={sectionTitle}>🏢 Leasing</div>

          <div style={gridStyle}>
            {["leasedProperties","leasedPercentage","leasedSqft","leasedRent","leasedQ1","leasedQ2","leasedQ3","leasedQ4"].map(field => (
              <div key={field} style={fieldWrapper}>
                <label style={labelStyle}>{field.replace(/([A-Z])/g, " $1").toLowerCase()}</label>
                <input
                  name={field}
                  value={config[field] || ""}
                  onChange={handleChange}
                  style={inputStyle}
                />
              </div>
            ))}
          </div>
        </div>

        {/* 🛠️ PPM */}
        <div style={cardStyle}>
          <div style={sectionTitle}>🛠️ PPM</div>

          <div style={gridStyle}>
            {["ppmTotal","ppmRed","ppmAmber","ppmGreen"].map(field => (
              <div key={field} style={fieldWrapper}>
                <label style={labelStyle}>{field.replace(/([A-Z])/g, " $1").toLowerCase()}</label>
                <input
                  name={field}
                  value={config[field] || ""}
                  onChange={handleChange}
                  style={inputStyle}
                />
              </div>
            ))}
          </div>
        </div>

        {/* 📁 Projects */}
        <div style={cardStyle}>
          <div style={sectionTitle}>📁 Projects</div>

          <div style={gridStyle}>
            {["projectsTotal","projectsRed","projectsAmber","projectsGreen"].map(field => (
              <div key={field} style={fieldWrapper}>
                <label style={labelStyle}>{field.replace(/([A-Z])/g, " $1").toLowerCase()}</label>
                <input
                  name={field}
                  value={config[field] || ""}
                  onChange={handleChange}
                  style={inputStyle}
                />
              </div>
            ))}
          </div>
        </div>

        <br />

        <button onClick={handleSave} style={buttonStyle} disabled={loading}>
          {loading ? "Saving..." : "Save Configuration"}
        </button>

        {loading && <div style={spinnerStyle} />}

        {message && (
          <div style={{ marginTop: "20px", fontWeight: "bold" }}>
            {message}
          </div>
        )}

      </div>

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>

    </div>
  );
}